import { HsbcTable } from "@/components/HsbcTable";

export const HsbcRevenueMix = ({ block, testId }) => {
  const components = block.rows.slice(0, 2);
  return <HsbcTable block={block} testId={testId}>
    <div className="hsbc-revenue-chart" data-testid={`${testId}-chart`} data-manuscript-duplicate="true"
      role="img" aria-label={`${block.caption}. ${components.map(([label, value, share]) => `${label}: US$${value}bn, ${share}`).join(". ")}. Total: US$${block.rows[2][1]}bn.`}>
      <div className="hsbc-revenue-bar" aria-hidden="true" data-testid={`${testId}-bar`}>
        {components.map(([label, value, share], index) => <div className={`hsbc-revenue-segment segment-${index}`} key={label} style={{ width: share }} data-value={value} data-share={share} data-testid={`${testId}-segment-${index}`} />)}
      </div>
      <div className="hsbc-revenue-labels" aria-hidden="true">
        {components.map(([label, value, share], index) => <div key={label} data-testid={`${testId}-chart-label-${index}`}>
          <span className={`hsbc-revenue-key segment-${index}`} />
          <div><span>{label}</span><strong>US${value}bn <span> | </span> {share}</strong></div>
        </div>)}
      </div>
    </div>
  </HsbcTable>;
};